export const codes = {
  'auth/wrong-password': 'Your email and/or password is incorrect',
  'auth/network-request-failed': 'Sorry there were some network issues',
  'auth/weak-password': 'Please enter a password of at least 6 characters',
  'auth/email-already-in-use': 'That email address is already in use'
};

export function getMessage(code) {
  return codes[code] || 'Sorry, something unexpected happened';
}



// WEBPACK FOOTER //
// ./src/utils/errorCodes.js